<template>
  <div>
    <template v-if="isHighPermission">
      <el-form>
        <div class="row">
          <div class="col-12 col-md-6 col-xl-4">
            <el-form-item
              :label="L10n('employee')"
              class="material-style">
              <select-response
                :model="value"
                @update:model="$emit('input', $event)"
                :data="dataSourceEmployee.records"
                :isLoading="dataSourceEmployee.isLoading"/>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </template>
    <template v-else>
      {{title}}
    </template>
  </div>
</template>

<script>
export default {
  name: 'TopPanel',
  props: {
    value: { default: null }
  },
  computed: {
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    currentUser () {
      return this.$store.getters.get('currentUser')
    },
    title () {
      return `${this.L10n('support-quote')} for ${this.currentUser.fullName}`
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    }
  }
}
</script>
